import { cn } from "@/lib/utils/ui";
import { Loader2 } from "lucide-react";
import React from "react";

interface LoadingSpinnerProps {
  className?: string;
}
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => {
  return <Loader2 className={cn("mr-2 h-4 w-4 animate-spin", className)} />;
};

export default LoadingSpinner;
